class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.lineKey, this.dataset.index, 0);
    });
  }
}

if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.cartDrawer = document.querySelector('cart-drawer');
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
   
    this.currentItems = {}
    Array.from(this.querySelectorAll('[name="updates[]"]')).map(item => {
      this.currentItems[item.id] = item.value;
    })
    
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    // catch event, either variant change or quantity change. If variant change, remove the item in the cart and add the new variant with the same quantity
    const type = event.target.dataset.changeType;
    
    if (type === 'variant') {
      // remove the old item first and when the cart has been updated, add the new variant.
      // this.updateQuantity(event.target.dataset.lineKey, event.target.dataset.index, 0, 'variantChange', event.target);
      this.updateVariant(event.target.dataset.lineKey, event.target);
    }
    // update quantity
    if (type === 'quantity') {
      this.updateQuantity(event.target.dataset.lineKey, event.target.dataset.index, +event.target.value, document.activeElement.getAttribute('name'));
    }
  }

  async updateQuantity(key, line, quantity, name) {
    const variantSelect = document.getElementById(`Variants-id-${line}`);
    
    this.enableLoading(line);

    const body = JSON.stringify({
      id: key,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    try {  
      const response = await fetch(routes.cart_change_url, {...fetchConfig(), ...{ body } });
      const parsedState = await response.json();
      
      // When quantity error
      if (!response.ok && parsedState.errors) {
        // update the sections
        this.updateLiveRegions(line, this.currentItemCount, variantSelect, quantity);
        this.disableLoading();
      } 
      else {

        // focus the element
        document.getElementById(`CartItem-${line}`)?.focus();

        if (this.cartDrawer) {
          this.classList.toggle(parsedState.sections['cart-drawer'] ? 'cart-drawer-is-empty' : 'is-empty', parsedState.item_count === 0);
        }
          
        document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);

        this.updateLiveRegions(line, parsedState.item_count, variantSelect, quantity);

        // update the sections
        this.renderSections(parsedState);

        // update the shipping bar
        this.updateShipping(parsedState);

        this.disableLoading();
        
      }
    }
    catch(error) {
      this.errorFunctions(error);
    }
  }

  /**
   * 
   * @param {String} currentVariant 
   * @param {Object} select 
   */
  updateVariant(currentVariant, select) {
    let quantity = +select.dataset.currentQuantity;

    // check if current qty is bigger than max inventory of the new variant
    const maxQuantity = +select.selectedOptions[0].dataset.inventoryQuantity;
    
    if (quantity > maxQuantity) {
      quantity = maxQuantity;
    }

    let updates = {};
    updates[currentVariant] = 0;
    updates[+select.value] = quantity;
    
    let body = JSON.stringify({
      ...{updates},
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    })

    fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((state) => {
        
        // update the sections
        this.renderSections(state);

        // because changed element is a new item in the cart, it's at the top, so scroll to it
        document.getElementById('main-cart-items')?.scrollTo({top: 0, behavior: 'smooth'});

        // update the shipping bar
        this.updateShipping(state);

        // clear errors
        this.updateLiveRegions(select.dataset.index, state.item_count, select, quantity, 'variantChange');
        
        this.disableLoading();
      })
      .catch((error) => {
        this.errorFunctions(error);
      });
  }

  errorFunctions(error) {
    debug() && console.error('Error updating item:', error);
    document.getElementById('cart-errors').textContent = window.cartStrings.error;
    this.disableLoading();
  }

  renderSections(state) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      if (document.querySelector(section.selector)) {
        elementToReplace.innerHTML = this.getSectionInnerHTML(state.sections[section.section], section.selector);
      }
    }));
  }

  updateShipping(parsedState) {
    const shippingBarWrapper = document.querySelector('[data-shipping-bar-wrapper]');
    if (shippingBarWrapper) {
      let shippingCurrent;

      // check if this is a quantity update from the drawer or a new add
      if (typeof parsedState.original_total_price !== 'undefined') {
        shippingCurrent = parsedState.original_total_price;
      }
      else {
        shippingCurrent = parseInt(shippingBarWrapper.dataset.shippingBarCurrent);
      }

      shippingBarWrapper.dataset.shippingBarCurrent = shippingCurrent;
      const shippingBarMax = shippingBarWrapper.dataset.shippingBarMax;
      const shippingBar = shippingBarWrapper.querySelector('[data-shipping-bar]');
      if (shippingBarMax > shippingCurrent) {
        document.querySelector('[data-shipping-bar-notification]').classList.remove('hidden');
        document.querySelector('[data-shipping-bar-qualified]').classList.add('hidden');
      }
      else {
        document.querySelector('[data-shipping-bar-notification]').classList.add('hidden');
        document.querySelector('[data-shipping-bar-qualified]').classList.remove('hidden');
      }
      shippingBar.style.width = `${shippingCurrent * 100 / shippingBarMax}%`;
    }
  }

  // show error texts, should not be deleted.
  updateLiveRegions(line, cartTotalCount, variantSelect, newQuantity, type = 'quantityChange') {
    const maxValue = (variantSelect) ? +variantSelect.selectedOptions[0].dataset.inventoryQuantity : +document.getElementById(`Quantity-${line}`).max;

    // set the max quantity, either the new quantity or the max inventory for this variant
    const quantity = (newQuantity > maxValue) ? maxValue : newQuantity;
    
    // only show the error when quantity is changed and exceeds max quantity
    if (type === 'quantityChange' && newQuantity > maxValue) {
      document.getElementById(`Line-item-error-${line}`)
      .querySelector('[data-error-text]')
      .innerHTML = window.cartStrings.quantityError.replace('[quantity]', quantity);

      // update the quantity input
      document.getElementById(`Quantity-${line}`).value = this.currentItems[`Quantity-${line}`];
    }
    else {
      document.getElementById(`Quantity-${line}`).value = quantity;
      // update the current quantity data attribute
    }

    if (variantSelect) {
      variantSelect.dataset.currentQuantity = quantity
    }
    this.currentItems[`Quantity-${line}`] = quantity;

    (cartTotalCount) && this.currentItemCount === cartTotalCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    document.querySelector('.loading-overlay').classList.remove('hidden');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
    document.querySelector('.loading-overlay').classList.add('hidden');
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.cart-shipping-notification__text',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-cart-item-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-cart-footer-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }
}

if (!customElements.get('cart-items')) {
  customElements.define('cart-items', CartItems);
}
